import { useState, useRef, useCallback } from "react";
import { ZERO, PREVENT_BUTTON_CLICK } from "../utils/constants/appConstants";

export const usePrventBtnClick = (lockoutMs = PREVENT_BUTTON_CLICK) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const lastClickTimeRef = useRef(ZERO);

  const isLocked = useCallback(() => {
    if (isProcessing) return true;
    const now = Date.now();
    if (now - lastClickTimeRef.current < lockoutMs) {
      return true;
    }
    lastClickTimeRef.current = now;
    return false;
  }, [isProcessing, lockoutMs]);

  return {
    isProcessing,
    isLocked,
    setIsProcessing
  };
};

export default usePrventBtnClick;
